import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import Exception from "../../shared/exception/Exception";
import portalConfiguration from "../../shared/configuration/PortalConfiguration";
import {pdfjs} from "react-pdf";
import Translate from "../../shared/translation/Translate";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class PdfContainer extends AbstractContainer {
	private loadingTask?: Promise<pdfjs.PDFDocumentProxy>;

	public clean(): void {
		if (this.loaded) {
			this.data.destroy();
		}

		if (FunctionHelper.exists(this.loadingTask)) {
			this.loadingTask = undefined;
		}

		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument): Promise<pdfjs.PDFDocumentProxy> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		if (FunctionHelper.exists((portalDocument.getDocumentFile()?.error)) &&
			portalDocument.getDocumentFile()?.error?.errorCode !== 0) {
			throw Exception.parseExceptionBean(portalDocument.getDocumentFile()!.error!);
		}

		if (FunctionHelper.exists(this.loadingTask)) {
			return this.loadingTask!;
		}

		if (this.loaded) {
			return this.data;
		}

		let loadingTask: pdfjs.PDFDocumentLoadingTask = pdfjs.getDocument(
			{
				data: this.data as Buffer,
				verbosity: portalConfiguration.debug ? pdfjs.VerbosityLevel.INFOS : pdfjs.VerbosityLevel.ERRORS,
				cMapUrl: 'cmap/',
				cMapPacked: true
			}
		);

		loadingTask.onPassword = (callback: (openPassword: string) => void, reason: number) => {
			if (reason === 1) {
				return;
			}

			this.loadingTask = undefined;

			if (reason === 2) {
				throw new Exception(Translate.value("viewerscreen.message.wrong_password", {ns: "screen"}));
			}

			throw Exception.parseExceptionBean(portalDocument.getDocumentFile()!.error!);
		};

		this.loadingTask = loadingTask.promise;

		try {
			this.data = await this.loadingTask;
			this.loaded = true;
		} catch (exception: any) {
			throw Exception.parseException(exception);
		}

		return this.loadingTask;
	}

	public async getNumberOfPages(data: pdfjs.PDFDocumentProxy) {
		return data.numPages;
	}

	public getType(): ViewerType {
		return ViewerType.PDF;
	}
}